import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-content',
	templateUrl: './content.component.html',
	styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {

	parentMenuId: string;

	constructor(
		private route: ActivatedRoute) { }

	ngOnInit() {
		this.route.params.subscribe(_ => {
			this.parentMenuId = this.route.snapshot.paramMap.get('id');
		});
	}

}
